<template>
  <div class="footer">
    <div class="footer-top">
      <div class="container">
        <div class="row">
          <div class="col-12 d-flex flex-wrap justify-content-between align-items-center">
            <img src="../assets/mc.png" alt="MasterCard" />
            <img src="../assets/skrill.png" alt="Skrill" />
            <img src="../assets/wire.png" alt="WireTransfer" />
            <img src="../assets/visa.png" alt="VISA" />
            <img src="../assets/neteller.png" alt="Neteller" />
          </div>
        </div>
      </div>
    </div>
    <div class="conteiner-fluid footer-bottom">
      <div class="row pb-5">
        <!-- 1 -->
        <div class="col-lg-2 col-md-2 col-md-2 col-12 offset-lg-2 offset-md-1 offset-0 footer-logo">
          <img src="../assets/logo.png" alt="TrioMarkets logo" />
        </div>
        <!-- 2 -->
        <div class="col-lg-2 col-md-2 col-sm-3 trioaddress">
          <ul>
            <li>TrioMarkets head office:</li>
            <li>Centro Office 301</li>
            <li>Grigori Afxentiou 11</li>
            <li>4003 Limassol, Cyprus</li>
          </ul>
        </div>
        <!-- 3 -->
        <div class="col-lg-2 col-md-2 col-sm-3 col-12 triocontacts">
          <ul>
            <li>
              <i class="fa fa-phone mr-2 mb-2"></i>+357 25 030056
            </li>
            <li>
              <i class="fa fa-fax mr-2 mb-2"></i>+357 25 250310
            </li>
            <li>
              <i class="fa fa-envelope mr-2"></i>info@triomarkets.eu
            </li>
          </ul>
        </div>
        <!-- 4 -->
        <div class="col-lg-1 col-md-2 col-sm-3 col-12 triosocial">
          <div class="triosocial-sm">
            <i class="fa fa-facebook mr-4"></i>
            <i class="fa fa-linkedin mr-4"></i>
            <i class="fa fa-twitter mr-4"></i>
            <i class="fa fa-youtube-play"></i>
          </div>
          <div class="row pb-4">
            <i class="fa fa-facebook mr-4"></i>
            <i class="fa fa-linkedin"></i>
          </div>
          <div class="row">
            <i class="fa fa-twitter mr-4"></i>
            <i class="fa fa-youtube-play"></i>
          </div>
        </div>
        <!-- 5 -->
        <div class="col-lg-2 col-md-2 col-sm-3 col-12 triomenu">
          <ul>
            <li>
              <a
                href="https://www.triomarkets.eu/legal-documents/Client-Service-Agreement.pdf"
                target="_blank"
              >Terms and conditions</a>
            </li>
            <li>
              <a
                href="https://www.triomarkets.eu/legal-documents/Privacy-Policy.pdf"
                target="_blank"
              >Privacy Policy</a>
            </li>
            <li>
              <a
                href="https://www.triomarkets.eu/legal-documents/Risk-Disclosure-Policy.pdf"
                target="_blank"
              >Risk disclosure policy</a>
            </li>
            <li>
              <a href="https://www.triomarkets.eu/downloads/PRIIP_KIDS.zip" target="_blank">PRIIP KIDS</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div
          class="col-lg-8 col-md-8 offset-lg-2 col-sm-12 col-12 offset-md-2 offset-0 text-justify"
        >
          <p>TrioMarkets is the trading name of EDR Financial Ltd, registered as a Cyprus Investment Firm («CIF») with the registration number (HE336081), under the Laws of the Republic of Cyprus. Licensed and regulated by the Cyprus Securities and Exchange Commission («CySEC») under license number 268/15, in accordance with Markets in Financial Instruments Directive II («MiFID ΙΙ») and Markets in Financial Instruments Directive («MiFID»), to the extent it is still applicable. All retail client funds are insured by the Investor Compensation Fund (Subject of eligibility).</p>
          <p
            class="pt-2"
          >Risk Warning: Trading in Forex and Contracts for Difference (CFDs) is highly speculative and involves a substantial risk of loss. Choosing a higher leverage on those products can lead to high losses. Following portfolio management or copying the trading activity of other traders, even though they may be professional traders (physical or legal persons) is not obligatory and cannot guarantee success. You should not trade CFDs and Forex either by yourself or with the use of an expert advisor (robot), or copy the trading activity of other traders, unless you are prepared to sustain a total loss of your initial investment (deposit). Therefore, Forex and CFDs may not be suitable for all investors. Before trading, assess your financial condition and your level of experience and only invest with money you can afford to lose. Past performance or the use of financial indicators are not reliable sources of information and cannot be indicative of future results. Any material used, published or distributed by TrioMarkets is used for marketing or educational –where applicable-purposes only and in no case can they be considered as investment advice or strategy or recommendation, implied or explicit, with respect to the trading of a financial instrument. If necessary, seek for independent advice. Please ensure that you fully understand the risks involved. For more information, please refer to our Risk Disclosure Policy.</p>
          <p class="text-center py-4">
            <a
              href="#"
            >Trade Responsibly: 81.66% of retail investor accounts lost money when trading CFDs with this provider</a>
          </p>
          <p class="text-center pb-1">
            Regional restrictions: EDR Financial does not provide services to residents of the United States of America, State of Israel, Islamic Republic of Iran and Democratic People's Republic of Korea (DPRK)
            The distribution is not addressed to the Belgian public
          </p>
          <p class="text-center">
            EDR FINANCIAL LIMITED - Inomenon Ethnon 48, Guricon House, Larnaca, 6042, Cyprus
            <br />TrioMarkets is a trademark owned by EDR Financial Ltd. All other trademarks that appear on this page are the property of their respective owners.
          </p>
          <div class="text-center pb-3">
            <small>&copy; {{new Date().getFullYear()}} All Rights Reserved</small>
          </div>
        </div>
      </div>
    </div>
    <div
      class="disclaimer"
      style="position: fixed; width: 100%; bottom: 0; left: 0; padding: 3px; text-align: center; font-size: 10pt; color: #fff; background: #000; z-index: 9999;"
    >Invest responsibly: CFDs are complex instruments and come with a high risk of losing money rapidly due to leverage. 73.60% of retail investor accounts lose money when trading CFDs with this provider. You should consider whether you understand how CFDs work and whether you can afford to take the high risk of losing your money.</div>
  </div>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style scoped lang="scss">
//colors
$payments-bg: #e9edf0;
$footer-bg: #000;
$youtube-bg: #f1141a;
$facebook-bg: #0e6fac;
$twitter-bg: #15b4c9;
$linkedin-bg: #338ff1;
$golden: #e7c68c;
$footer-text-color: #fff;

//sizes
$footer-font-size: 16px;

ul,
li {
  list-style: none;
}

.row {
  margin: auto;
}

.footer-top {
  padding: 5px 0;
  background: $payments-bg;
}

.footer-bottom {
  background: $footer-bg;
  padding-top: 60px;
  padding-bottom: 10px;
  color: $footer-text-color;
  font-size: $footer-font-size;
  a {
    text-decoration: none;
    color: $golden;
  }
  .trioaddress {
    border-right: 1px #fff solid;
    @media screen and (min-width: 983px) {
      max-width: 14%;
    }
  }
  .triosocial {
    border-right: 1px #fff solid;
    i {
      padding: 12px;
      border-radius: 50%;
    }
    .fa-facebook {
      padding-right: 15px;
      padding-left: 15px;
      background-color: $facebook-bg;
    }
    .fa-linkedin {
      background-color: $linkedin-bg;
    }
    .fa-twitter {
      background-color: $twitter-bg;
    }
    .fa-youtube-play {
      background-color: $youtube-bg;
    }
  }
  .triomenu {
    li {
      padding-bottom: 5px;
      a {
        color: $footer-text-color;
        &::before {
          content: ">";
          margin-right: 5px;
          @media screen and (max-width: 768px) {
            content: "";
          }
        }
      }
    }
  }
}

a,
p,
li,
li a,
i {
  @media screen and (max-width: 1480px) {
    font-size: 0.9rem;
  }
  @media screen and (max-width: 1278px) {
    font-size: 0.8rem;
  }
  @media screen and (max-width: 983px) {
    font-size: 0.7rem;
  }
  @media screen and (max-width: 575px) {
    font-size: 1em;
  }
}
.footer-logo {
  @media screen and (max-width: 983px) {
    text-align: center;
  }
  img {
    @media screen and (max-width: 1480px) {
      max-width: 250px;
    }
    @media screen and (max-width: 1278px) {
      max-width: 200px;
    }
    @media screen and (max-width: 983px) {
      max-width: 150px;
      padding-bottom: 25px;
    }
    @media screen and (max-width: 575px) {
      max-width: 100%;
    }
  }
}

.trioaddress,
.triomenu,
.triocontacts {
  @media screen and (max-width: 575px) {
    text-align: center;
  }
}
.triosocial {
  @media screen and (max-width: 575px) {
    display: none;
  }
}
.triosocial-sm {
  @media screen and (min-width: 576px) {
    display: none;
  }
}
</style>
